import { render, staticRenderFns } from "./updatedSiteFooter.vue?vue&type=template&id=79cb3d2c&scoped=true"
import script from "./updatedSiteFooter.vue?vue&type=script&lang=js"
export * from "./updatedSiteFooter.vue?vue&type=script&lang=js"
import style0 from "./updatedSiteFooter.vue?vue&type=style&index=0&id=79cb3d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb3d2c",
  null
  
)

export default component.exports